import { render, staticRenderFns } from "./CustomerService.vue?vue&type=template&id=4430d95a&scoped=true"
import script from "./CustomerService.vue?vue&type=script&lang=js"
export * from "./CustomerService.vue?vue&type=script&lang=js"
import style0 from "./CustomerService.vue?vue&type=style&index=0&id=4430d95a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4430d95a",
  null
  
)

export default component.exports